/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {combineReducers} from 'redux'
import {
    ADD_NEW_ERROR_PATH,
    ADD_NEW_UI_ELEMENT,
    ADD_TODO,
    ERROR,
    INFO,
    MARKASREAD,
    REMOVE_ERROR,
    REMOVE_ERROR_PATH,
    REMOVE_UI_ELEMENT,
    SET_TAB_SELECTION,
    STORE_VARIABLES,
    TOGGLE_TODO,
    UPDATE_LAYOUT_SESSION,
    UPDATE_UI_ELEMENT_STATE,
    WARNING
} from './actions.jsx'


// This handles the error Process
function websocketData(state = [], action) {
    switch (action.type) {
        case ADD_TODO:
            return action.text;
        case ERROR:
        case WARNING:
        case INFO:
            return [
                ...state,
                action
            ];
        case MARKASREAD:
            return state.map((message, index) => {
                if (message.id === action.data.messageId) {
                    return Object.assign({}, message, {
                        isRead: true
                    })
                }
                return message
            });
        case REMOVE_ERROR:

            return state.filter(item => action.data !== item.errorSourcePath);

        case TOGGLE_TODO:
            return state.map((todo, index) => {
                return index === action.index ? Object.assign({}, todo, {
                    completed: !todo.completed
                }) : todo;
            });
        default:
            return state
    }
}

// This stores a query
function cachingData(state = [], action) {
    return {...state, [action.type]: {data: action.data, isLoaded: action.isLoaded}};
}


// This manages the error paths on the page
function errorPathArray(state = [], action) {
    switch (action.type) {
        case ADD_NEW_ERROR_PATH:
            return state.includes(action.data) ? state : [
                ...state,
                action.data
            ];

        case REMOVE_ERROR_PATH:
            let index = state.indexOf(action.data);
            if (index > -1) {
                state.splice(index, 1)
                return state;
            } else {
                return state
            }
        default:
            return state
    }
}

// this stores the last selected tabs
function tabSelections(state = [], action) {
    switch (action.type) {
        case SET_TAB_SELECTION:
            // After the 5 stored value gets the storage truncated
            // TODO: Better way of clearing the storage without notice of the user for example remove the oldest one
            let objectKeys = Object.keys(action.data)
            if (objectKeys.length > 5) {
                return {};
            } else {
                return action.data

            }

        default:
            return state
    }
}


// this stores the global variables
function variableCache(state = {}, action) {
    switch (action.type) {
        case STORE_VARIABLES:
            if (state[action.Prefix] === undefined) {
                state[action.Prefix] = {}
            }
            state[action.Prefix][action.Name] = action.Value
            return state

        default:
            return state
    }
}

// this stores manages the UI elements
function uiGenerator(state = {}, action) {
    switch (action.type) {
        case ADD_NEW_UI_ELEMENT:
            state[action.uiId] = {
                uiId: action.uiId,
                elementType: action.elementType,
                content: action.content,
                callbackOnClose: action.callbackOnClose,
                settings: action.settings,
                openTime: action.openTime,
                inputState: {}
            }
            return state
        case REMOVE_UI_ELEMENT:
            delete state[action.uiId]
            return state ?? {}

        case UPDATE_UI_ELEMENT_STATE:
            state[action.uiId] = state[action.uiId] ?? {}
            state[action.uiId].inputState = {...(state[action.uiId]?.inputState ?? {}), ...action.newState}
            return state

        default:
            return state
    }
}

// layout session store
function layoutSessionStore(state = {}, action) {
    switch (action.type) {
        case UPDATE_LAYOUT_SESSION:
            state = action.sessionData
            return state

        default:
            return state
    }
}


//  notification store
function notificationStore(state = [], action) {
    // limit the errors to 2000
    state = state.slice((state.length - 2000), state.length)


    switch (action.type) {
        case ERROR:
        case WARNING:
        case INFO:
            state.push(action)
            return state
        case MARKASREAD:
            return state.map((message, index) => {
                if (message.id === action.data.messageId) {
                    return Object.assign({}, message, {
                        isRead: true
                    })
                }
                return message
            });
        default:
            return state
    }
}


export const todoApp = combineReducers({
    websocketData,
    errorPathArray,
    cachingData,
    variableCache,
    tabSelections,
    uiGenerator,
    layoutSessionStore
});


export const layoutSession = combineReducers({
    layoutSessionStore
});


export const notification = combineReducers({
    notificationStore
});
